import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import * as filialService from "../services/filialService";
import * as terapiaService from "../services/terapiaService";

// El filtro de filial de los reportes.
//
// Un usuario con una filial asignada solo ve esa; uno sin filial (idFilial 0)
// ve todas. Es el mismo criterio que usan los filtros de las ventanas de
// navegacion.
//
// Ademas da los terapeutas que tienen terapias activas en cada filial: el
// filtro de filial sirve para listarlos, que es lo que se busca en el reporte
// de sesiones.
export const useFiltroFilial = () => {
    const idFilialUsuario = useSelector((state) => state.seguridad?.idFilial) || 0;

    const [filiales, setFiliales] = useState([]);
    const [idFilial, setIdFilial] = useState(0);
    const [terapeutasPorFilial, setTerapeutasPorFilial] = useState({});
    const [terapeutasListos, setTerapeutasListos] = useState(false);

    useEffect(() => {
        const cargar = async () => {
            const lista = await filialService.getFilialesList().catch(() => []);

            setFiliales(filialService.soloFilialDelUsuario(lista, idFilialUsuario));

            // El usuario con una filial ya viene con ella miseada.
            if (idFilialUsuario > 0) setIdFilial(idFilialUsuario);
        };

        cargar();
    }, [idFilialUsuario]);

    // Los terapeutas con terapias activas en cada filial.
    useEffect(() => {
        terapiaService.getsTerapiasActivas(true)
            .then((terapias) => {
                const mapa = {};

                for (const terapia of (terapias || [])) {
                    const id = terapia.idFilial || 0;

                    if (!mapa[id]) mapa[id] = [];

                    const yaEsta = mapa[id].some((t) => t.id === terapia.idTerapeuta);

                    if (terapia.idTerapeuta > 0 && !yaEsta) {
                        // Con la misma forma que la lista de terapeutas que
                        // usa el reporte (id y descripcion).
                        mapa[id].push({ id: terapia.idTerapeuta, descripcion: terapia.terapeuta || "" });
                    }
                }

                setTerapeutasPorFilial(mapa);
                setTerapeutasListos(true);
            })
            .catch((err) => {
                console.log("Err: ", err);
                setTerapeutasListos(true);
            });
    }, []);

    // Los terapeutas de la filial elegida. Sin filial, los de todas.
    const terapeutas = useMemo(() => {
        if (idFilial > 0) return terapeutasPorFilial[idFilial] || [];

        return Object.values(terapeutasPorFilial).flat();
    }, [terapeutasPorFilial, idFilial]);

    return {
        filiales,
        idFilial,
        setIdFilial,
        terapeutas,
        terapeutasListos,
        // Con filial asignada el filtro queda fijo en esa.
        bloqueado: idFilialUsuario > 0,
    };
};

export default useFiltroFilial;
